import DotsGrid from "@untitled-ui/icons-react/build/esm/DotsGrid";
import List from "@untitled-ui/icons-react/build/esm/List";
import RefreshCcw01 from "@untitled-ui/icons-react/build/esm/RefreshCcw01";
import RefreshCcw05 from "@untitled-ui/icons-react/build/esm/RefreshCcw05";
import SettingsIcon from "@untitled-ui/icons-react/build/esm/Settings01";
import { Tooltip } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router";
import styled from "styled-components";
import AppContext from "../../../../AppContext";
import { ReactComponent as ChevronDown } from "../../../../assets/icons/chevron-down.svg";
import { ReactComponent as IconHand } from "../../../../assets/icons/hand.svg";
import { ReactComponent as IconSearch } from "../../../../assets/icons/icon-search.svg";
import { ReactComponent as IconTrash } from "../../../../assets/icons/trash-01.svg";
import { ReactComponent as IconUpload } from "../../../../assets/icons/upload-01.svg";
import { ReactComponent as XCloseIcon } from "../../../../assets/icons/x-close0.svg";
import { ReactComponent as IconClose } from "../../../../assets/icons/x-close1.svg";
import LayoutContext from "../../../../LayoutContext";
import useDebounce from "../../../../utils/hooks/useDebounce";
import * as Library from "../../../../utils/Library";
import BtnLargeSolid from "../../buttons/BtnLargeSolid";
import Checkbox from "../../checkbox/Checkbox";
import FormField, { defaultPlaceholderTextFunction } from "../../forms/FormField";
import FormFieldTextAutocomplete from "../../forms/FormFieldTextAutocomplete";
import FullScreenOverlay from "../../overlay/FullScreenOverlay";
import { premiumListingToolbarStyles, PremiumListingDropdownStyles } from "../../premium/PremiumListingToolbarStyles";

// #region  SCOPED CSS
export const MainWindowStyledPage = styled.div`
    &.main-window-header {
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding: 15px 24px;
    }

    &.main-window-header,
    &.main-window-header * {
        box-sizing: border-box;
    }

    // Custom requirement: overrides global gray locked state to display green
    .firstOrganize .Frame48.locked .Frame48Input label,
    .secondOrganize .Frame48.locked .Frame48Input label,
    .thirdOrganize .Frame48.locked .Frame48Input label {
        color: var(--text-icons-green-500) !important;
    }

    .property-1-default-locked {
        background: var(--backgrounds-and-lines-n-600, #10141b);
        //padding: 15px 24px 15px 24px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        height: 37px;
        position: relative;
    }
    .frame-1000011372 {
        display: flex;
        flex-direction: row;
        gap: 6px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313369 {
        background: var(--backgrounds-and-lines-n-300, #1a222d);
        border-radius: 4px;
        padding: 8px 16px 8px 16px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-3133692 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-end;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313371 {
        display: flex;
        flex-direction: row;
        gap: 12px;
        align-items: center;
        justify-content: flex-end;
        flex-shrink: 0;
        position: relative;
    }
    .checkbox {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        top: -2px;
    }
    .rectangle-1 {
        background: var(--backgrounds-and-lines-n-600, #10141b);
        border-radius: 4px;
        border-style: solid;
        border-color: var(--backgrounds-and-lines-n-100, #3c485a);
        border-width: 1px;
        width: 100%;
        height: 100%;
        position: absolute;
        right: 0%;
        left: 0%;
        bottom: 0%;
        top: 0%;
    }
    .check {
        opacity: 0;
        width: 62.5%;
        height: 62.5%;
        position: absolute;
        right: 18.75%;
        left: 18.75%;
        bottom: 18.75%;
        top: 18.75%;
        overflow: visible;
    }
    .select-all {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: var(--subtitle-2-font-size, 12px);
        font-weight: var(--subtitle-2-font-weight, 400);
        position: relative;
    }
    .frame-313372 {
        display: flex;
        flex-direction: row;
        gap: 6px;
        align-items: center;
        justify-content: flex-end;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313368 {
        background: var(--backgrounds-and-lines-n-300, #1a222d);
        border-radius: 4px;
        padding: 8px 10px 8px 16px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-end;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-3133712 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-end;
        flex-shrink: 0;
        position: relative;
    }
    ._0-selected {
        text-align: left;
        font-size: var(--subtitle-2-font-size, 12px);
        font-weight: var(--subtitle-2-font-weight, 400);
        position: relative;
    }
    .x-close {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .frame-259 {
        display: flex;
        flex-direction: row;
        gap: 6px;
        align-items: center;
        justify-content: flex-end;
        flex-shrink: 0;
        position: relative;
    }
    .f-group-selections {
        display: flex;
        flex-direction: column;
        gap: 2px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .icon-search {
        flex-shrink: 0;
        width: 40px;
        height: 37px;
        position: relative;
        //transform-origin: 0 0;
        //transform: rotate(0deg) scale(-1, 1);
    }
    .frame-29,
    .frame-29-active,
    .frame-29-not-hoverable {
        background: var(--buttons-all-platforms-gray-300, #1e2631);
        border-radius: 4px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        position: absolute;
        right: 0%;
        left: 0%;
        bottom: 0%;
        top: 0%;
    }
    div:not(.button-disabled) > .frame-29:hover {
        background: var(--App-Accent-Active);
        color: #ffffff;
    }
    .frame-29-active {
        background: var(--App-Accent-Active) !important;
        color: #ffffff !important;
    }
    .trash-01 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .hand {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .upload-01 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .frame-260 {
        display: flex;
        flex-direction: row;
        gap: 6px;
        align-items: center;
        justify-content: flex-end;
        flex-shrink: 0;
        //width: 1170px;
        position: relative;
    }
    .frame-1000011374 {
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 100%;
        max-width: 283px;
        position: relative;
    }
    .frame-1000011374.responsive {
        width: auto !important;
        max-width: 357px;
        position: relative;
        flex-grow: 1;
        flex-shrink: 1;
        min-width: 120px;
    }

    .frame-51 {
        background: var(--backgrounds-and-lines-n-500, #141922);
        border-radius: 4px 0px 0px 4px;
        padding: 6px 0px 6px 0px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 5px;
        height: 37px;
        position: relative;
        overflow: hidden;
    }
    .frame-48 {
        background: var(--buttons-all-platforms-gray-300, #1e2631);
        border-radius: 0px 4px 4px 0px;
        padding: 6px 12px 6px 12px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        flex: 1;
        height: 37px;
        position: relative;
        overflow: hidden;
    }
    .search {
        color: var(--text-and-icons-gray-200, #7c868b);
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        font-style: italic;
        position: relative;
    }
    .search-sm {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .input-selector-inverted {
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 288px;
        height: 37px;
        position: relative;
    }
    .frame-50 {
        background: var(--text-and-icons-gray-300, #4f5b6d);
        border-radius: 4px 0px 0px 4px;
        padding: 6px 0px 6px 0px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 5px;
        height: 37px;
        position: relative;
        overflow: hidden;
    }
    .search2 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        height: 37px;
        position: relative;
    }
    .frame-482 {
        background: var(--buttons-all-platforms-gray-300, #1e2631);
        border-radius: 0px 4px 4px 0px;
        padding: 6px 12px 6px 12px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        height: 37px;
        position: relative;
        overflow: hidden;
    }
    .div {
        color: var(--text-and-icons-gray-300, #4f5b6d);
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .chevron-right {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .chevron-right2 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .frame-1000011379 {
        display: flex;
        flex-direction: row;
        gap: 6px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313361 {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: center;
        justify-content: flex-end;
        flex-shrink: 0;
        //width: 288px;
        position: relative;
    }
    .frame-3133682 {
        background: var(--buttons-all-platforms-gray-300, #1e2631);
        border-radius: 4px;
        padding: 8px 16px 8px 16px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-end;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-3133713 {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-end;
        flex-shrink: 0;
        position: relative;
    }
    .organize {
        //color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: var(--subtitle-2-font-size, 12px);
        font-weight: var(--subtitle-2-font-weight, 400);
        position: relative;
    }
    .chevron-down {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .icon-list,
    .icon-list-hoverable {
        display: flex;
        flex-direction: column;
        gap: 2px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }

    .icon-list-hoverable {
        cursor: default;
        //border: 1px solid transparent;
    }
    .icon-list-hoverable:hover {
        cursor: pointer;
        box-shadow: 0px 0px 0px 1px var(--App-Accent-Outline) !important;
        border-radius: 4px;
    }
    .icon-list-hoverable-active {
        cursor: pointer;
        box-shadow: 0px 0px 0px 1px var(--App-Accent-Outline) !important;
        border-radius: 4px;
    }
    .refresh-ccw-01 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .refresh-ccw-05 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .icon-toggler {
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .frame-292 {
        background: var(--buttons-all-platforms-gray-300, #1e2631);
        background: var(--bostageb-green-active, #008800);
        border-radius: 4px 0px 0px 4px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 40px;
        height: 37px;
        position: relative;
    }
    .dots-grid {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .frame-293 {
        background: var(--buttons-all-platforms-gray-300, #1e2631);
        border-radius: 0px 4px 4px 0px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 40px;
        height: 37px;
        position: relative;
    }

    .list {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .frame-1000011379 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1000011377 {
        display: flex;
        flex-direction: row;
        gap: 6px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }

    .button-disabled {
        cursor: not-allowed !important;
        color: var(--text-and-icons-gray-300) !important;
    }
    .button-disabled::placeholder {
        color: var(--text-icons-gray-300) !important;
    }

    .button-enabled {
        cursor: pointer;
        color: var(--text-and-icons-gray-100) !important;
    }

    .button-enabled-trash {
        cursor: pointer;
        color: var(--bostageb-red-active, #ff2d55) !important;
    }

    .button-enabled-hand {
        cursor: pointer;
        color: var(--bostageb-orange-active, #f90) !important;
    }

    .button-enabled-upload {
        cursor: pointer;
    }

    .btn-group .filter-btn:hover,
    .btn-group .filter-btn:focus,
    .btn-group .filter-btn:active {
        border-color: var(--App-Accent-Active) !important;
        background-color: var(--App-Accent-Active) !important;
        outline: none !important;
    }

    /*.btn-group .filter-btn.disabled:hover,
    .btn-group .filter-btn.disabled:focus {
        background-color: var(--backgrounds-lines-n-400) !important;
        color: var(--text-icons-gray-100) !important;
    }*/

    .filter-btn.grid-btn.disabled,
    .filter-btn.list-btn.disabled {
        opacity: 1 !important;
    }

    .filter-btn.grid-btn.disabled svg,
    .filter-btn.list-btn.disabled svg {
        color: var(--text-and-icons-gray-300, #4f5b6d) !important;
    }

    .filter-btn.grid-btn.disabled:hover,
    .filter-btn.list-btn.disabled:hover {
        background-color: var(--backgrounds-lines-n-400) !important;
        border-color: transparent !important;
    }

    .btn-group .filter-btn.active,
    .btn-group .filter-btn:hover,
    .btn-group .filter-btn:focus {
        color: #ffffff !important;
    }

    .btn-group .filter-btn.active {
        background: var(--App-Accent-Active);
        border: 1px solid var(--App-Accent-Active);
    }

    .filter-btn {
        width: 40px;
        height: 37px !important;
        font-size: 16px;
        background-color: var(--backgrounds-lines-n-400);
        border-color: var(--Buttons-All-Platforms-Gray-300);
        color: var(--text-icons-gray-100);
    }

    .filter-btn {
    }

    .filter-btn:focus {
        outline: none !important;
    }

    .filter-btn.disabled:focus {
        background-color: var(--backgrounds-lines-n-400) !important;
    }

    .organize-btn-container {
        position: absolute;
        top: calc(100% + 8px);
        left: 0;
        z-index: 1000;
        display: flex;
        flex-direction: column;
        gap: 4px;
        background: var(--backgrounds-lines-n-500, #141922);
        border-radius: 4px;
        padding: 8px;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
        min-width: 245px;
        min-height: 50px;
    }

    .settings-btn-container {
        position: absolute;
        top: calc(100% + 8px);
        //left: 0;
        right: 0;
        z-index: 1000;
        display: flex;
        flex-direction: column;
        gap: 4px;
        background: var(--backgrounds-lines-n-500, #141922);
        border-radius: 4px;
        padding: 8px;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
        min-width: 245px;
        min-height: 50px;
    }

    .upload-btn-container {
        position: absolute;
        top: calc(100% + 8px);
        left: 0;
        //right: 0;
        z-index: 1000;
        display: flex;
        flex-direction: column;
        gap: 4px;
        background: var(--backgrounds-lines-n-500, #141922);
        border-radius: 4px;
        padding: 8px;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
        min-width: 245px;
        min-height: 50px;
    }

    .product-name-ean-code {
        color: var(--text-and-icons-gray-200, #7c868b);
        text-align: left;
        font-family: "Roboto-Italic", sans-serif;
        font-size: 12px;
        font-weight: 400;
        font-style: italic;
        position: relative;
        flex: 1;
        background: transparent;
        border: none;
        outline: none;
        min-width: 100px;
    }
    .product-name-ean-code.has-value {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-family:
            "Roboto",
            -apple-system,
            BlinkMacSystemFont,
            sans-serif;
        font-style: normal;
    }
    ${props => props.$premium && premiumListingToolbarStyles}

`;

const FilterHeaderStyles = styled.div`
    .filter-btn {
        width: 40px;
        height: 37px;
        font-size: 16px;
        background-color: var(--backgrounds-lines-n-400);
        border-color: var(--backgrounds-lines-n-400);
        color: var(--text-icons-gray-100);
    }

    .organize-select {
        width: 100px;
        //min-width: 290px;
    }

    .organize-select .placeholder {
        font-style: normal;
        color: var(--text-icons-gray-100, #d1d1d1);

        /* Subtitle 2 */
        font-family: Roboto;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .organize-select.disabled .placeholder {
        color: var(--text-icons-gray-300);
    }

    .new-organize-select,
    .new-organize-select * {
        box-sizing: border-box;
    }
    .new-organize-select {
        background: var(--backgrounds-and-lines-n-300, #1a222d);
        border-radius: 4px;
        padding: 8px 16px 8px 16px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-end;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .new-organize-select.disabled .organize-text,
    .new-organize-select.disabled .chevron-down {
        color: var(--text-icons-gray-300) !important;
    }
    .new-organize-select.disabled path {
        stroke: var(--text-icons-gray-300) !important;
    }
    .frame-313371 {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-end;
        flex-shrink: 0;
        position: relative;
    }
    .organize-text {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--subtitle-2-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-2-font-size, 12px);
        font-weight: var(--subtitle-2-font-weight, 400);
        position: relative;
    }
    .chevron-down {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }

    .not-allowed {
        color: var(--text-icons-gray-300);
        cursor: not-allowed;
    }

    .filter-container {
        display: flex;
        gap: 6px;
    }

    .view-type-select .active {
        border-color: var(--App-Accent-Active);
        background-color: var(--App-Accent-Active);
    }

    .btn-group .filter-btn:hover,
    .btn-group .filter-btn:focus,
    .btn-group .filter-btn:active {
        border-color: var(--App-Accent-Active) !important;
        background-color: var(--App-Accent-Active) !important;
        outline: none !important;
    }

    .btn-group .filter-btn.disabled:hover {
        background-color: var(--backgrounds-lines-n-400) !important;
    }

    .filter-btn:focus {
        outline: none !important;
    }

    .filter-btn.disabled:focus {
        background-color: var(--backgrounds-lines-n-400) !important;
    }

    .organize-select-field .Frame-50 {
        display: none !important;
    }
`;

const OrganizeButtonStyles = styled.div`
    &.frame-349,
    &.frame-349 * {
        box-sizing: border-box;
    }
    &.frame-349 {
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-348 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: center;
        flex: 1;
        position: relative;
    }
    .frame-75 {
        background: var(--backgrounds-and-lines-n-400, #1e2631);
        border-radius: 4px;
        padding: 8px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        z-index: 99999;
    }
    .frame-75.disabled {
        background: var(--backgrounds-and-lines-n-400, #1e2631);
        cursor: not-allowed;
    }
    .frame-75.disabled .label {
        color: var(--text-icons-gray-300);
        cursor: not-allowed;
    }
    .frame-75:hover:not(.disabled) {
        background: var(--backgrounds-and-lines-n-300, #1a222d);
    }
    .label {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 14px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
`;

export const StyledCustomSearch = styled.div`
    &.CustomSearch {
        display: flex;
        gap: 16px;
        align-items: center;
        //width: 312px;
        position: relative;
    }

    &.highlighted .FormField.custom-search.simple {
        border: 1px solid var(--App-Accent-Active);
        border-radius: 4px;
    }

    .frame-48 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        position: absolute;
        z-index: 999;
        right: 17px;
    }

    /* @media only screen and (max-width: 1756px) {
        &.isSidePanelOpen.CustomSearch .frame-48.no-value {
            display: none !important;
        }
    } */

    .x {
        width: 16px;
        height: 16px;
    }

    .FormComponentContainer {
        width: 300px;
        margin-right: 8px;
    }
`;
// #endregion

/** Main Window Header provides a header with search and organize options for the main window of the application.
 *
 * @param {Object} props
 * @param {boolean} [props.hidden=false] - If true, the component will be hidden.
 * @param {string} [props.className] - Additional classes to be added to the component.
 * @param {Object} [props.selections] - Selections object containing selection related properties.
 * @param {boolean} [props.selections.visible=true] - If true, selection related properties will be visible.
 * @param {boolean} [props.selections.enabled=false] - If true, selection related properties will be enabled.
 * @param {boolean} [props.selections.allSelected=false] - If true, all items are selected.
 * @param {number} [props.selections.selectedCount=0] - Number of selected items.
 * @param {function} [props.selections.onClearSelection] - Function to be called when clear selection button is clicked.
 * @param {function} [props.selections.onSelectAll] - Function to be called when select all button is clicked.
 * @param {function} [props.selections.onDeleteClick] - Function to be called when delete button is clicked.
 * @param {function} [props.selections.onSuspendClick] - Function to be called when suspend button is clicked.
 * @param {Object} [props.firstOrganize] - First organize object containing organize related properties.
 * @param {boolean} [props.firstOrganize.visible=true] - If true, first organize related properties will be visible.
 * @param {string} [props.firstOrganize.usePlaceholderText="--"] - Placeholder text to be used in the dropdown.
 * @param {Array} [props.firstOrganize.dropdownData] - Data to be used in the dropdown.
 * @param {string} [props.firstOrganize.selectedValue] - Selected value in the dropdown.
 * @param {function} [props.firstOrganize.onDropdownChange] - Function to be called when dropdown value is changed.
 * @param {boolean} [props.firstOrganize.disabled=true] - If true, dropdown will be disabled.
 * @param {string} [props.firstOrganize.type="singleSelect"] - Type of the dropdown. (singleSelect or multiSelect)
 * @param {Object} [props.firstOrganize.multidropdownOptions] - Options for the multi select dropdown. View the FormField multidropdownOptions prop for more details.
 * @param {boolean} [props.firstOrganize.multidropdownOptions.useDoneButton=true] - If true, show done button in the multi select dropdown.
 * @param {boolean} [props.firstOrganize.multidropdownOptions.useSelectAll=false] - If true, show select all option in the multi select dropdown.
 * @param {string} [props.firstOrganize.multidropdownOptions.selectAllText="Select all"] - Text to be used for the select all option in the multi select dropdown.
 * @param {string} [props.firstOrganize.multidropdownOptions.selectAllDescription="Select all"] - Description to be used for the select all option in the multi select dropdown.
 * @param {function} [props.firstOrganize.multidropdownOptions.placeholderTextFunction] - Function to retrieve the placeholder text based on the selected values.
 * @param {Array} [props.firstOrganize.multidropdownOptions.allItems] - All items including not selected items, for reference to the placeholderTextFunction.
 * @param {string} [props.firstOrganize.multidropdownOptions.labelAllSelected="All selected"] - Text to be used for the all selected option in the multi select dropdown.
 * @param {string} [props.firstOrganize.multidropdownOptions.labelNoneSelected="--"] - Text to be used for the none selected option in the multi select dropdown.
 * @param {boolean} [props.firstOrganize.onlyOneDisableDropdown=true] - If true, if there is only one element, dropdown will be disabled. (ONLY APPLICABLE FOR SINGLE SELECT!)
 * @param {string} [props.firstOrganize.tooltipTitle="--"] - Tooltip title to be used in the dropdown.
 * 
 * @param {Object} [props.secondOrganize] - Second organize object containing organize related properties.
 * @param {boolean} [props.secondOrganize.visible=false] - If true, second organize related properties will be visible.
 * @param {string} [props.secondOrganize.usePlaceholderText="--"] - Placeholder text to be used in the dropdown.
 * @param {Array} [props.secondOrganize.dropdownData] - Data to be used in the dropdown.
 * @param {string} [props.secondOrganize.selectedValue] - Selected value in the dropdown.
 * @param {function} [props.secondOrganize.onDropdownChange] - Function to be called when dropdown value is changed.
 * @param {boolean} [props.secondOrganize.disabled=true] - If true, dropdown will be disabled.
 * @param {string} [props.secondOrganize.type="singleSelect"] - Type of the dropdown. (singleSelect or multiSelect)
 * @param {Object} [props.secondOrganize.multidropdownOptions] - Options for the multi select dropdown. View the FormField multidropdownOptions prop for more details.
 * @param {boolean} [props.secondOrganize.multidropdownOptions.useDoneButton=true] - If true, show done button in the multi select dropdown.
 * @param {boolean} [props.secondOrganize.multidropdownOptions.useSelectAll=false] - If true, show select all option in the multi select dropdown.
 * @param {string} [props.secondOrganize.multidropdownOptions.selectAllText="Select all"] - Text to be used for the select all option in the multi select dropdown.
 * @param {string} [props.secondOrganize.multidropdownOptions.selectAllDescription="Select all"] - Description to be used for the select all option in the multi select dropdown.
 * @param {Array} [props.secondOrganize.multidropdownOptions.allItems] - All items including not selected items, for reference to the placeholderTextFunction.
 * @param {function} [props.secondOrganize.multidropdownOptions.placeholderTextFunction] - Function to retrieve the placeholder text based on the selected values.
 * @param {string} [props.secondOrganize.multidropdownOptions.labelAllSelected="All selected"] - Text to be used for the all selected option in the multi select dropdown.
 * @param {string} [props.secondOrganize.multidropdownOptions.labelNoneSelected="--"] - Text to be used for the none selected option in the multi select dropdown.
 * @param {boolean} [props.secondOrganize.onlyOneDisableDropdown=true] - If true, if there is only one element, dropdown will be disabled. (ONLY APPLICABLE FOR SINGLE SELECT!))
 * @param {string} [props.secondOrganize.tooltipTitle="--"] - Tooltip title to be used in the dropdown.
 * 
 * @param {Object} [props.thirdOrganize] - Third organize object containing organize related properties.
 * @param {boolean} [props.thirdOrganize.visible=false] - If true, third organize related properties will be visible.
 * @param {string} [props.thirdOrganize.usePlaceholderText="--"] - Placeholder text to be used in the dropdown.
 * @param {Array} [props.thirdOrganize.dropdownData] - Data to be used in the dropdown.
 * @param {string} [props.thirdOrganize.selectedValue] - Selected value in the dropdown.
 * @param {function} [props.thirdOrganize.onDropdownChange] - Function to be called when dropdown value is changed.
 * @param {boolean} [props.thirdOrganize.disabled=true] - If true, dropdown will be disabled.
 * @param {string} [props.thirdOrganize.type="multiSelect"] - Type of the dropdown. (singleSelect or multiSelect)
 * @param {Object} [props.thirdOrganize.multidropdownOptions] - Options for the multi select dropdown. View the FormField multidropdownOptions prop for more details.
 * @param {boolean} [props.thirdOrganize.multidropdownOptions.useDoneButton=true] - If true, show done button in the multi select dropdown.
 * @param {boolean} [props.thirdOrganize.multidropdownOptions.useSelectAll=false] - If true, show select all option in the multi select dropdown.
 * @param {string} [props.thirdOrganize.multidropdownOptions.selectAllText="Select all"] - Text to be used for the select all option in the multi select dropdown.
 * @param {function} [props.thirdOrganize.multidropdownOptions.placeholderTextFunction] - Function to retrieve the placeholder text based on the selected values.
 * @param {Array} [props.thirdOrganize.multidropdownOptions.allItems] - All items including not selected items, for reference to the placeholderTextFunction.
 * @param {string} [props.thirdOrganize.multidropdownOptions.labelAllSelected="All selected"] - Text to be used for the all selected option in the multi select dropdown.
 * @param {string} [props.thirdOrganize.multidropdownOptions.labelNoneSelected="--"] - Text to be used for the none selected option in the multi select dropdown.
 * @param {boolean} [props.thirdOrganize.onlyOneDisableDropdown=true] - If true, if there is only one element, dropdown will be disabled. (ONLY APPLICABLE FOR SINGLE SELECT!)
 * @param {string} [props.thirdOrganize.tooltipTitle="--"] - Tooltip title to be used in the dropdown.

 * @param {Object} [props.organizeButton] - Organize button object containing organize button related properties.
 * @param {boolean} [props.organizeButton.visible=true] - If true, organize button will be visible.
 * @param {boolean} [props.organizeButton.enabled=false] - If true, organize button will be enabled.
 * @param {React.Component} [props.organizeButton.layoutComponent] - Layout component to be used in the organize button.
 * @param {string} [props.organizeButton.className] - Additional classes to be added to the organize button container.
 * @param {Object} [props.organizeButton.style] - Additional styles to be added to the organize button container.
 * @param {function} [props.onResetClick] - Function to be called when reset button is clicked.
 * @param {function} [props.onRefreshClick] - Function to be called when refresh button is clicked.
 * @param {Object} [props.settingsButton] - Settings button object containing settings button related properties.
 * @param {boolean} [props.settingsButton.visible=false] - If true, settings button will be visible.
 * @param {boolean} [props.settingsButton.enabled=true] - If true, settings button will be enabled.
 * @param {boolean} [props.settingsButton.active=false] - If true, settings button will be active.
 * @param {boolean} [props.settingsButton.outlined=false] - If true, settings button will be forced to be outlined.
 * @param {string} [props.settingsButton.className] - Additional classes to be added to the settings button container.
 * @param {Object} [props.settingsButton.style] - Additional styles to be added to the settings button container.
 * @param {React.Component} [props.settingsButton.layoutComponent] - Layout component to be used in the settings button.
 * @param {Object} [props.uploadButton] - Upload button object containing upload button related properties.
 * @param {boolean} [props.uploadButton.visible=false] - If true, upload button will be visible.
 * @param {boolean} [props.uploadButton.enabled=true] - If true, upload button will be enabled.
 * @param {string} [props.uploadButton.className] - Additional classes to be added to the upload button container.
 * @param {Object} [props.uploadButton.style] - Additional styles to be added to the upload button container.
 * @param {string} [props.uploadButton.tooltipTitle="Export All"] - Tooltip title to be displayed on hover.
 * @param {React.Component} [props.uploadButton.layoutComponent] - Layout component to be used in the upload button.
 * @param {Object} [props.layoutTypeOptions] - Layout type options object containing layout type related properties.
 * @param {boolean} [props.layoutTypeOptions.hideGridList=false] - If true, grid and list buttons will be hidden.
 * @param {boolean} [props.layoutTypeOptions.gridEnabled=true] - If true, grid button will be enabled.
 * @param {boolean} [props.layoutTypeOptions.listEnabled=true] - If true, list button will be enabled.
 * @param {function} [props.layoutTypeOptions.onLayoutTypeChange] - Function to be called when layout type is changed.
 * @param {Object} [props.layoutTypeOptions.useLayoutButton] - Layout button options object containing layout button related properties.
 * @param {boolean} [props.layoutTypeOptions.useLayoutButton.useInsteadOfGridList=false] - If true, use button instead of grid/list.
 * @param {string} [props.layoutTypeOptions.useLayoutButton.text="SAVE"] - Text to be displayed on the button if useInsteadOfGridList is true.
 * @param {boolean} [props.layoutTypeOptions.useLayoutButton.enabled=true] - If true, button will be enabled.
 * @param {function} [props.layoutTypeOptions.useLayoutButton.onClick] - Function to be called when button is clicked.
 * @param {Object} [props.search] - Search object containing search related properties.
 * @param {boolean} [props.search.visible=true] - If true, search will be visible.
 * @param {string} [props.search.searchPlaceholder="Search"] - Placeholder text to be used in the search input.
 * @param {function} [props.search.onSearch] - Function to be called when search input value is changed.
 * @param {Object} [props.pageFilters] - Page filters object containing page filters related properties.
 * @param {boolean} [props.pageFilters.useFilters=false] - If true, page filters will be used.
 * @param {Object} [props.customFiltersList] - its is the filter list other than getFilters means its custom you can add custom data
 * @param {function} [props.pageFilters.onFiltersLoaded] - Function to be called when filters are loaded.
 * @param {Object} [props.pageFilters.filters] - Filters object containing filter related properties.
 * @param {boolean} [props.pageFilters.filters.useLabelBrands=false] - If true, label brands filter will be used.
 * @param {boolean} [props.pageFilters.filters.useRetailBrands=false] - If true, retail brands filter will be used.
 * @param {boolean} [props.pageFilters.filters.useStores=false] - If true, stores filter will be used.
 * @param {boolean} [props.pageFilters.filters.useProductsCollections=false] - If true, product collections filter will be used.
 * @param {boolean} [props.pageFilters.filters.useBOImagesCollections=false] - If true, BOImages collections filter will be used.
 * @param {boolean} [props.pageFilters.filters.useConnectedLabelBrands=false] - If true, connected label brands filter will be used.
 * @param {boolean} [props.pageFilters.filters.useConnectedRetailBrands=false] - If true, connected retail brands filter will be used.
 * @param {boolean} [props.pageFilters.filters.useConnectedStores=false] - If true, connected stores filter will be used.
 * @param {boolean} [props.pageFilters.filters.useConnectedProductCollections=false] - If true, connected product collections filter will be used.
 * @param {boolean} [props.pageFilters.filters.useConnectedProductSeasons=false] - If true, connected product seasons filter will be used.
 * @param {boolean} [props.pageFilters.filters.useCompanies=false] - If true, companies filter will be used.
 * @param {boolean} [props.pageFilters.filters.useProductSeasons=false] - If true, product seasons filter will be used.
 * @param {boolean} [props.pageFilters.filters.usePOSSystems=false] - If true, POS systems filter will be used.
 * @returns {JSX.Element} - Rendered MainWindowHeader component.
 */
export default function MainWindowHeader(props) {
    const {
        hidden = false,
        premium = false,
        className = "",
        selections = {
            visible: true,
            enabled: false,
            allSelected: false,
            selectedCount: 0,
            onClearSelection: undefined,
            onSelectAll: undefined,
            onDeleteClick: undefined,
            onSuspendClick: undefined
        },
        firstOrganize = {
            visible: true,
            usePlaceholderText: "--",
            dropdownData: undefined,
            selectedValue: undefined,
            onDropdownChange: undefined,
            disabled: true,
            type: "singleSelect", //singleSelect or multiSelect
            multidropdownOptions: {},
            onlyOneDisableDropdown: true,
            tooltipTitle: "All brands"
        },
        secondOrganize = {
            visible: false,
            usePlaceholderText: "--",
            dropdownData: undefined,
            selectedValue: undefined,
            onDropdownChange: undefined,
            disabled: true,
            type: "singleSelect", //singleSelect or multiSelect
            multidropdownOptions: {},
            onlyOneDisableDropdown: true,
            tooltipTitle: "--"
        },
        thirdOrganize = {
            visible: false,
            usePlaceholderText: "--",
            dropdownData: undefined,
            selectedValue: undefined,
            onDropdownChange: undefined,
            disabled: true,
            type: "multiSelect",
            multidropdownOptions: {},
            onlyOneDisableDropdown: true,
            tooltipTitle: "--"
        },
        organizeButton = {
            visible: true,
            enabled: false,
            layoutComponent: undefined,
            className: "",
            style: {}
        },
        onResetClick,
        onRefreshClick,
        settingsButton = {
            visible: false,
            enabled: false,
            active: false,
            outlined: false,
            layoutComponent: undefined,
            className: "",
            style: {}
        },
        uploadButton = {
            visible: true,
            enabled: false,
            layoutComponent: undefined,
            className: "",
            style: {},
            tooltipTitle: "Export All"
        },

        layoutTypeOptions = {
            hideGridList: false,
            gridEnabled: true,
            listEnabled: true,
            onLayoutTypeChange: undefined,
            useLayoutButton: {
                useInsteadOfGridList: false,
                text: "SAVE",
                enabled: true,
                onClick: undefined
            }
        },
        search = {
            visible: true,
            searchPlaceholder: "Search",
            onSearch: undefined
        },
        pageFilters = {
            useFilters: false,
            onFiltersLoaded: undefined,
            filters: {
                useLabelBrands: false,
                useRetailBrands: false,
                useStores: false,
                useProductsCollections: false,
                useBOImagesCollections: false,
                useConnectedLabelBrands: false,
                useConnectedRetailBrands: false,
                useConnectedStores: false,
                useConnectedProductCollections: false,
                useConnectedProductSeasons: false,
                useCompanies: false,
                useProductSeasons: false,
                usePOSSystems: false
            },
            useCustomFilters: false
        }
    } = props;

    // #region VARS
    //contexts and misc:
    const { layoutType, setLayoutType } = useContext(LayoutContext);
    const { isLoadingApp, aiChatSidePanelOpen } = useContext(AppContext);
    const location = useLocation();

    //states:
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [organizeContainerOpen, setOrganizeContainerOpen] = useState(false);
    const [settingsContainerOpen, setSettingsContainerOpen] = useState(false);
    const [uploadContainerOpen, setUploadContainerOpen] = useState(false);
    const [searchInput, setSearchInput] = useState("");
    const [loadingFilters, setLoadingFilters] = useState(false);
    const [filtersData, setFiltersData] = useState(undefined);
    const debouncedText = useDebounce(searchInput, 600);

    //computed vars: (constants calculated based on other vars)
    const widthLessThanLarge = !aiChatSidePanelOpen ? windowWidth < 1800 : windowWidth < 2148;
    const widthLessThanMedium = !aiChatSidePanelOpen ? windowWidth < 1506 : windowWidth < 2148;
    const widthLessThanSmall = windowWidth < 1143;
    // #endregion

    // #region EFFECTS
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        Library.scrollWindowToTop();

        //Set layout type to default on component mount (Grid by default)
        if (layoutTypeOptions?.listEnabled && !layoutTypeOptions?.gridEnabled) setLayoutType("List");
        else setLayoutType("Grid");
    }, [location]);

    useEffect(() => {
        if (!filtersData) return;

        if (pageFilters?.onFiltersLoaded) pageFilters.onFiltersLoaded(filtersData);
    }, [filtersData]);

    useEffect(() => {
        if (!pageFilters?.useFilters) return;

        getStockPageFilters();
    }, [pageFilters?.useFilters]);

    useEffect(() => {
        const handleClickOutside = e => {
            //check if className is "SVGAnimatedString" because when clicking on svg elements it would always close the dropdown
            const isSVG = e.target?.className?.toString?.() === "[object SVGAnimatedString]";

            if (
                organizeContainerOpen &&
                !e.target.closest(".organize-btn-container") &&
                !e.target.closest(".frame-3133682") &&
                !isSVG
            ) {
                setOrganizeContainerOpen(false);
            }
        };
        document.addEventListener("click", handleClickOutside);

        return () => document.removeEventListener("click", handleClickOutside);
    }, [organizeContainerOpen]);

    useEffect(() => {
        const handleClickOutside = e => {
            //check if className is "SVGAnimatedString" because when clicking on svg elements it would always close the dropdown
            const isSVG = e.target?.className?.toString?.() === "[object SVGAnimatedString]";

            if (
                settingsContainerOpen &&
                !e.target.closest(".settings-btn-container") &&
                //!e.target.closest(".frame-3133682") && -> this is wrong
                !e.target.closest(".settings-btn") &&
                !isSVG
            ) {
                setSettingsContainerOpen(false);
            }
        };
        document.addEventListener("click", handleClickOutside);

        return () => document.removeEventListener("click", handleClickOutside);
    }, [settingsContainerOpen]);

    useEffect(() => {
        const handleClickOutside = e => {
            //check if className is "SVGAnimatedString" because when clicking on svg elements it would always close the dropdown
            const isSVG = e.target?.className?.toString?.() === "[object SVGAnimatedString]";

            if (
                uploadContainerOpen &&
                !e.target.closest(".upload-btn-container") &&
                !e.target.closest(".upload-btn") &&
                !isSVG
            ) {
                setUploadContainerOpen(false);
            }
        };
        document.addEventListener("click", handleClickOutside);

        return () => document.removeEventListener("click", handleClickOutside);
    }, [uploadContainerOpen]);

    useEffect(() => {
        // If search input is debounced, call the search function
        if (debouncedText && search?.onSearch) {
            search.onSearch(debouncedText);
        } else if (search?.onSearch && !debouncedText) {
            search.onSearch("");
        }
    }, [debouncedText]);
    // #endregion

    // #region METHODS
    const handleLayoutChange = layout => {
        if (layout === "List" && !layoutTypeOptions?.listEnabled) return;
        if (layout === "Grid" && !layoutTypeOptions?.gridEnabled) return;

        setLayoutType(layout);
        if (layoutTypeOptions?.onLayoutTypeChange) layoutTypeOptions.onLayoutTypeChange(layout);
    };

    const handleLayoutButtonClick = () => {
        if (layoutTypeOptions?.useLayoutButton?.onClick && layoutTypeOptions?.useLayoutButton?.enabled) {
            layoutTypeOptions.useLayoutButton.onClick();
        }
    };

    const handleSearchChange = e => {
        setSearchInput(e.target.value);
        //if (search?.onSearch) search.onSearch(e.target.value);
        if (search?.onSearch && debouncedText) search.onSearch(debouncedText);
        else if (search?.onSearch && !debouncedText) search.onSearch("");
    };

    const getStockPageFilters = async () => {
        const filtersArray = [];

        if (pageFilters?.filters?.useLabelBrands) filtersArray.push("Label Brands");
        if (pageFilters?.filters?.useRetailBrands) filtersArray.push("Retail Brands");
        if (pageFilters?.filters?.useStores) filtersArray.push("Stores");
        if (pageFilters?.filters?.useProductsCollections) filtersArray.push("Product Collections");
        if (pageFilters?.filters?.useBOImagesCollections) filtersArray.push("BOimage Collections");
        if (pageFilters?.filters?.useConnectedLabelBrands) filtersArray.push("Connected Label Brands");
        if (pageFilters?.filters?.useConnectedRetailBrands) filtersArray.push("Connected Retail Brands");
        if (pageFilters?.filters?.useConnectedStores) filtersArray.push("Connected Stores");
        if (pageFilters?.filters?.useConnectedProductCollections) filtersArray.push("Connected Product Collections");
        if (pageFilters?.filters?.useConnectedProductSeasons) filtersArray.push("Connected Product Seasons");
        if (pageFilters?.filters?.useCompanies) filtersArray.push("Companies");
        if (pageFilters?.filters?.useProductSeasons) filtersArray.push("Product Seasons");
        if (pageFilters?.filters?.usePOSSystems) filtersArray.push("POS Systems");

        const res = await Library.makeCommonPostRequest(
            "Global",
            "getFilters",
            {
                companyID: localStorage.getItem("currentCompanyID"),
                organizationID: localStorage.getItem("currentOrganizationID"),
                filters: filtersArray
            },
            false,
            setLoadingFilters
        );

        const data = res?.data?.data;
        if (res?.status !== 200) setFiltersData([]);

        setFiltersData({ ...data, customFilters: pageFilters?.customFiltersList });
    };

    const handleSelectAllClick = () => {
        if (selections?.allSelected) selections?.onClearSelection();
        else selections?.onSelectAll(true);
    };
    // #endregion

    return (
        <>
            <FullScreenOverlay isLoading={loadingFilters && !isLoadingApp} />
            {premium && <PremiumListingDropdownStyles />}

            <MainWindowStyledPage $premium={premium} className={`main-window-header ${className} ${hidden ? "d-none" : ""}`}>
                <div className="property-1-default-locked">
                    <div className={`frame-1000011372 ${selections?.visible ? "" : "d-none"}`}>
                        <div
                            className={`frame-313369 ${selections?.enabled ? "cursor-pointer" : "hover-not-allowed"}`}
                            onClick={handleSelectAllClick}>
                            <div className="frame-3133692">
                                <div className="frame-313371">
                                    <Checkbox
                                        className="checkbox"
                                        disabled={!selections?.enabled}
                                        isChecked={selections?.allSelected}
                                    />
                                    <div
                                        className={`select-all ${
                                            selections?.enabled && selections?.selectedCount
                                                ? "text-active"
                                                : "text-inactive"
                                        }`}>
                                        Select all
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={`frame-313372 ${selections?.enabled ? "cursor-pointer" : "hover-not-allowed"}`}>
                            <div className="frame-313368">
                                <div className="frame-3133692">
                                    <div
                                        className={`frame-3133712 ${
                                            selections?.selectedCount > 0 ? "text-active" : "text-inactive"
                                        }`}>
                                        <div className="_0-selected">{`${selections?.selectedCount} selected`}</div>
                                        <IconClose
                                            className={`x-close ${
                                                selections?.selectedCount > 0 ? "cursor-pointer" : ""
                                            }`}
                                            onClick={selections?.onClearSelection}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="frame-259">
                                <Tooltip title="Delete selected" placement="top">
                                    <div className="f-group-selections">
                                        <div
                                            className={`icon-search ${
                                                selections?.onDeleteClick && selections?.selectedCount > 0
                                                    ? "button-enabled-trash"
                                                    : "button-disabled"
                                            }`}
                                            onClick={selections?.onDeleteClick}>
                                            <div className="frame-29">
                                                <IconTrash className="trash-01" />
                                            </div>
                                        </div>
                                    </div>
                                </Tooltip>
                                <Tooltip title="Suspend selected" placement="top">
                                    <div className="f-group-selections">
                                        <div
                                            className={`icon-search ${
                                                selections?.onSuspendClick && selections?.selectedCount > 0
                                                    ? "button-enabled-hand"
                                                    : "button-disabled"
                                            }`}
                                            onClick={selections?.onSuspendClick}>
                                            <div className="frame-29">
                                                <IconHand className="hand" />
                                            </div>
                                        </div>
                                    </div>
                                </Tooltip>

                                {uploadButton?.visible && (
                                    <Tooltip title={uploadButton?.tooltipTitle ?? "Export all"} placement="top">
                                        <div className="f-group-selections upload-button">
                                            <div
                                                className={`icon-search upload-btn ${
                                                    uploadButton?.enabled ? "button-enabled-upload" : "button-disabled"
                                                }`}
                                                onClick={() =>
                                                    uploadButton?.enabled &&
                                                    setUploadContainerOpen(!uploadContainerOpen)
                                                }>
                                                <div className="frame-29">
                                                    <IconUpload className="upload-01" />
                                                    <div
                                                        className={`upload-btn-container ${uploadButton?.className} ${
                                                            uploadContainerOpen ? "open" : "d-none"
                                                        }`}
                                                        style={uploadButton?.style}>
                                                        {uploadButton?.layoutComponent}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Tooltip>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="frame-260">
                        <SearchComponent
                            visible={!widthLessThanLarge && search?.visible}
                            searchData={search}
                            searchInput={searchInput}
                            handleSearchChange={handleSearchChange}
                        />

                        <OrganizeDropdownSelector
                            premium={premium}
                            visible={!widthLessThanMedium}
                            className="firstOrganize"
                            organize={firstOrganize}
                            type={firstOrganize?.type}
                            tooltipTitle={firstOrganize?.tooltipTitle || "All brands"}
                        />

                        <OrganizeDropdownSelector
                            premium={premium}
                            visible={!widthLessThanMedium}
                            className="secondOrganize"
                            organize={secondOrganize}
                            type={secondOrganize?.type}
                            tooltipTitle={secondOrganize?.tooltipTitle || "Filter"}
                        />
                        <OrganizeDropdownSelector
                            premium={premium}
                            visible={!widthLessThanMedium}
                            className="thirdOrganize"
                            organize={thirdOrganize}
                            type={thirdOrganize?.type}
                            tooltipTitle={thirdOrganize?.tooltipTitle || "Filter"}
                        />

                        <div className="frame-1000011379">
                            <div className="frame-313361">
                                <div
                                    className={`frame-313372 ${
                                        organizeButton?.enabled ? "button-enabled" : "button-disabled"
                                    }`}>
                                    {organizeButton?.visible && (
                                        <Tooltip title="Organize" placement="top">
                                            <div
                                                className={`frame-3133682 ${
                                                    organizeButton?.enabled ? "button-enabled" : "button-disabled"
                                                }`}
                                                onClick={() =>
                                                    organizeButton?.enabled &&
                                                    setOrganizeContainerOpen(!organizeContainerOpen)
                                                }>
                                                <div className="frame-3133692">
                                                    <div className="frame-3133713">
                                                        <div className="organize">Organize</div>
                                                        <ChevronDown
                                                            className={`chevron-right2 ${
                                                                organizeButton?.enabled
                                                                    ? "button-enabled"
                                                                    : "button-disabled"
                                                            }`}
                                                        />
                                                    </div>
                                                </div>

                                                <div
                                                    className={`organize-btn-container ${organizeButton?.className} ${
                                                        organizeContainerOpen ? "open" : "d-none"
                                                    }`}
                                                    style={organizeButton?.style}>
                                                    {organizeButton?.layoutComponent}
                                                </div>
                                            </div>
                                        </Tooltip>
                                    )}

                                    <div className="frame-259">
                                        <Tooltip title="Filter to default" placement="top">
                                            <div className="icon-list">
                                                <div
                                                    className={`icon-search ${
                                                        onResetClick ? "button-enabled" : "button-disabled"
                                                    }`}
                                                    onClick={onResetClick}>
                                                    <div className="frame-29">
                                                        <RefreshCcw01
                                                            className={`refresh-ccw-01 ${
                                                                onResetClick ? "button-enabled" : "button-disabled"
                                                            }`}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </Tooltip>
                                        <Tooltip title="Refresh list" placement="top">
                                            <div className="icon-list">
                                                <div
                                                    className={`icon-search ${
                                                        onRefreshClick ? "button-enabled" : "button-disabled"
                                                    }`}
                                                    onClick={onRefreshClick}>
                                                    <div className="frame-29">
                                                        <RefreshCcw05
                                                            className={`refresh-ccw-05 ${
                                                                onRefreshClick ? "button-enabled" : "button-disabled"
                                                            }`}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </Tooltip>
                                        {settingsButton?.visible && (
                                            <Tooltip title="Settings" placement="top">
                                                <div
                                                    className={
                                                        settingsButton?.enabled
                                                            ? settingsContainerOpen || settingsButton?.outlined
                                                                ? "icon-list-hoverable-active"
                                                                : "icon-list-hoverable"
                                                            : "icon-list-disabled"
                                                    }>
                                                    <div
                                                        className={`icon-search settings-btn ${
                                                            settingsButton?.enabled
                                                                ? "button-enabled"
                                                                : "button-disabled"
                                                        }`}
                                                        onClick={() =>
                                                            settingsButton?.enabled &&
                                                            setSettingsContainerOpen(!settingsContainerOpen)
                                                        }>
                                                        <div
                                                            className={
                                                                settingsButton?.active
                                                                    ? "frame-29-active"
                                                                    : "frame-29-not-hoverable"
                                                            }>
                                                            <SettingsIcon
                                                                className={`refresh-ccw-05 ${
                                                                    settingsButton?.enabled
                                                                        ? "button-enabled"
                                                                        : "button-disabled"
                                                                }`}
                                                            />
                                                            <div
                                                                className={`settings-btn-container ${
                                                                    settingsButton?.className
                                                                } ${settingsContainerOpen ? "open" : "d-none"}`}
                                                                style={settingsButton?.style}>
                                                                {settingsButton?.layoutComponent}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Tooltip>
                                        )}
                                    </div>
                                </div>

                                <span
                                    className="view-type-select"
                                    style={{
                                        display:
                                            layoutTypeOptions?.hideGridList ||
                                            layoutTypeOptions?.useLayoutButton?.useInsteadOfGridList
                                                ? "none"
                                                : "block"
                                    }}>
                                    <div className="btn-group flex">
                                        <Tooltip title="Grid view" placement="top">
                                            <button
                                                type="button"
                                                className={`btn filter-btn grid-btn ${
                                                    layoutType === "Grid" && layoutTypeOptions?.gridEnabled
                                                        ? "active"
                                                        : ""
                                                } ${!layoutTypeOptions?.gridEnabled ? "disabled" : ""}`}
                                                onClick={() => handleLayoutChange("Grid")}>
                                                <DotsGrid width={"16px"} />
                                            </button>
                                        </Tooltip>
                                        <Tooltip title="Table view" placement="top">
                                            <button
                                                type="button"
                                                className={`btn filter-btn list-btn ${
                                                    layoutType === "List" && layoutTypeOptions?.listEnabled
                                                        ? "active"
                                                        : ""
                                                } ${!layoutTypeOptions?.listEnabled ? "disabled" : ""}`}
                                                onClick={() => handleLayoutChange("List")}>
                                                <List width={"16px"} />
                                            </button>
                                        </Tooltip>
                                    </div>
                                </span>

                                <span
                                    className="view-type-select"
                                    style={{
                                        display: layoutTypeOptions?.useLayoutButton?.useInsteadOfGridList
                                            ? "block"
                                            : "none",
                                        width: "79px"
                                    }}>
                                    <BtnLargeSolid
                                        disabled={layoutTypeOptions?.useLayoutButton?.enabled !== true}
                                        className="w-100"
                                        style={{
                                            height: "37px",
                                            border:
                                                layoutTypeOptions?.useLayoutButton?.enabled !== true
                                                    ? "1px solid var(--backgrounds-lines-n-100, #3C485A)"
                                                    : "1px solid transparent"
                                        }}
                                        textStyle={{ fontSize: "12px" }}
                                        activeColor="var(--App-Accent-Outline, #ff9900)"
                                        normalColor="var(--App-Accent-Accent, #d37e00)"
                                        hoverColor="var(--App-Accent-Hover, #e48900)"
                                        disabledColor="var(--Buttons-All-Platforms-Gray-500, #10141b)"
                                        onClick={() => handleLayoutButtonClick()}>
                                        {layoutTypeOptions?.useLayoutButton?.text ?? "SAVE"}
                                    </BtnLargeSolid>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                {widthLessThanLarge && (
                    <div
                        className="frame-1000011379"
                        style={{
                            justifyContent: !widthLessThanSmall ? "space-between" : "right"
                        }}>
                        <SearchComponent
                            visible={widthLessThanLarge && search?.visible}
                            responsive={true}
                            searchData={search}
                            searchInput={searchInput}
                            handleSearchChange={handleSearchChange}
                        />

                        <div className="frame-1000011377">
                            <OrganizeDropdownSelector
                            premium={premium}
                                visible={widthLessThanMedium}
                                className="firstOrganize"
                                organize={firstOrganize}
                                type={firstOrganize?.type}
                                dropdownStyle={{ right: firstOrganize?.type === "multiSelect" ? "69%" : "" }}
                                tooltipTitle={"Connected to"}
                            />

                            <OrganizeDropdownSelector
                            premium={premium}
                                visible={widthLessThanMedium}
                                className="secondOrganize"
                                organize={secondOrganize}
                                type={secondOrganize?.type}
                                dropdownStyle={{ right: secondOrganize?.type === "multiSelect" ? "69%" : "" }}
                                tooltipTitle={"Filter"}
                            />

                            <OrganizeDropdownSelector
                            premium={premium}
                                visible={widthLessThanMedium}
                                className="thirdOrganize"
                                organize={thirdOrganize}
                                type={thirdOrganize?.type}
                                tooltipTitle={"All statuses"}
                            />
                        </div>
                    </div>
                )}
            </MainWindowStyledPage>
        </>
    );
}

// #region SMALL COMPONENTS
const SearchComponent = props => {
    const { visible = true, responsive = false, searchData, searchInput, handleSearchChange } = props;
    const { searchPlaceholder, onSearch } = searchData;

    return (
        <div className={`frame-1000011374 ${responsive ? "responsive" : ""} ${visible ? "" : "d-none"}`}>
            <div className="frame-51"></div>
            <div className="frame-48">
                {/*<div className="search">Search</div>*/}
                <input
                    type="text"
                    disabled={!onSearch}
                    className={`product-name-ean-code ${onSearch ? "" : "button-disabled cursor-disabled"} ${
                        searchInput ? "has-value" : ""
                    }`}
                    placeholder={searchPlaceholder}
                    value={searchInput}
                    onChange={handleSearchChange}
                />
                <IconSearch
                    className={`search-sm ${onSearch ? "text-active" : "text-inactive"} ${
                        !searchInput ? "" : "d-none"
                    }`}
                />
                <IconClose
                    className={`x-icon ${searchInput ? "cursor-pointer text-active" : "d-none"}`}
                    onClick={() => handleSearchChange({ target: { value: "" } })}
                />
            </div>
        </div>
    );
};

export const OrganizeDropdownSelector = props => {
    const type = props?.type || "singleSelect";
    const visible = props?.visible && props?.organize?.visible;
    const hoverTooltip = props?.tooltipTitle;
    const { className } = props;

    const { multidropdownOptions } = props?.organize || {};

    // destructuring all the props from multidropdownOptions
    const defaultMultidropdownOptions = {
        useDoneButton: multidropdownOptions?.useDoneButton ?? true,
        useSelectAll: multidropdownOptions?.useSelectAll ?? true,
        selectAllText: multidropdownOptions?.selectAllText ?? "Select all",
        selectAllDescription: multidropdownOptions?.selectAllDescription,
        placeholderTextFunction: multidropdownOptions?.placeholderTextFunction || defaultPlaceholderTextFunction,
        allItems: multidropdownOptions?.allItems,
        labelAllSelected: multidropdownOptions?.labelAllSelected ?? "All selected",
        labelNoneSelected: multidropdownOptions?.labelNoneSelected ?? "--"
    };

    const updatedOrganize = {
        ...props?.organize,
        multidropdownOptions: defaultMultidropdownOptions
    };

    return (
        <div className={`${className} input-selector-inverted ${visible ? "visible" : "d-none"}`}>
            {type === "singleSelect" ? (
                <OrganizeSingleDropdown {...props} organize={updatedOrganize} hoverTooltip={hoverTooltip} />
            ) : type === "multiSelect" ? (
                <OrganizeMultiDropdown {...props} organize={updatedOrganize} hoverTooltip={hoverTooltip} />
            ) : (
                <div>ERROR</div>
            )}
        </div>
    );
};

const OrganizeSingleDropdown = props => {
    const [defaultDropdownData] = useState([{ value: "", name: "--", id: "", selected: true }]);
    const {
        dropdownData,
        selectedValue,
        onDropdownChange,
        disabled,
        onlyOneDisableDropdown = true,
        usePlaceholderText
    } = props?.organize || {};
    const { dropdownStyle, hoverTooltip } = props;

    const isDisabled = disabled || (onlyOneDisableDropdown && dropdownData?.length === 1);

    const computedRequiredType = isDisabled
        ? "locked"
        : !selectedValue && dropdownData?.length > 0 && dropdownData?.[0]?.name !== "--"
          ? "mandatory"
          : "simple";

    return (
        <FilterHeaderStyles className={"input-selector-inverted2 button-disabled w-100"}>
            <FormField
                className="w-100"
                type="dropdown"
                {...(props.premium ? { dropdownWithinViewport: true, dropdownListMaxHeight: 280 } : {})}
                dropdownData={dropdownData || defaultDropdownData}
                value={selectedValue}
                onDropdownChange={onDropdownChange}
                varName="dropdownSingleItem"
                isDropdownMultiselect={false}
                isDropdownSearchable={true}
                styling={{
                    backgroundColor: "var(--backgrounds-lines-n-400)",
                    requiredTypeColor: isDisabled ? "var(--backgrounds-lines-n-500, #141922)" : undefined,
                    dropdownOverlayTop: "45px",
                    ...(props.premium ? { formFieldWidth: "100%", dropdownOverlayWidth: "320px" } : {}),
                    dropdownOverlayStyle: props.premium ? { "--premium-listing-overlay": 1 } : dropdownStyle
                }}
                requiredType={computedRequiredType}
                disableTooltip={true}
                hoverTooltip={hoverTooltip}
                placeholder={usePlaceholderText}
            />
        </FilterHeaderStyles>
    );
};

const OrganizeMultiDropdown = props => {
    const [defaultDropdownData] = useState([{ value: "", name: "--", id: "", selected: true }]);
    const {
        dropdownData,
        selectedValue,
        onDropdownChange,
        disabled,
        dropdownOnSingleItemClick,
        multidropdownOptions,
        noDataDisableTag = true
    } = props?.organize || {};
    const { dropdownStyle, hoverTooltip } = props;

    // #region METHODS
    const updatedOnDropdownChange = (selectedItems, allItems) => {
        const noneSelected = selectedItems?.length === 0;

        //if noneSelected then force all selected
        if (noneSelected) {
            allItems = allItems.map(item => ({
                ...item,
                selected: true
            }));
            selectedItems = allItems;
        }

        // Call the original onDropdownChange function with the updated data
        if (onDropdownChange) {
            onDropdownChange(selectedItems, allItems);
        }
    };
    // #endregion

    // #region COMPUTED PROPERTIES
    const useDropdownPlaceholderAsTag = !(noDataDisableTag && dropdownData?.length === 0);

    // Inline menus refresh FormField's label while hidden; deferred portals do not.
    // Supply only the premium display value, using the same formatter and committed selections.
    const displayValue = props.premium && selectedValue === undefined
        ? (multidropdownOptions?.placeholderTextFunction || defaultPlaceholderTextFunction)(
            (dropdownData || defaultDropdownData).filter(item => item.selected),
            multidropdownOptions?.allItems || dropdownData || defaultDropdownData,
            multidropdownOptions?.labelAllSelected,
            multidropdownOptions?.labelNoneSelected
        )
        : selectedValue;

    const computedRequiredType = disabled
        ? "locked"
        : !selectedValue && dropdownData?.length > 0 && dropdownData?.[0]?.name !== "--"
          ? "mandatory"
          : "simple";

    // #endregion

    return (
        <FilterHeaderStyles className={"input-selector-inverted2 button-disabled w-100"}>
            <FormField
                className="w-100"
                type="dropdown"
                {...(props.premium ? { dropdownWithinViewport: true, dropdownListMaxHeight: 280 } : {})}
                dropdownData={dropdownData || defaultDropdownData}
                value={displayValue}
                onDropdownChange={updatedOnDropdownChange}
                varName="dropdownSingleItem"
                isDropdownMultiselect={true}
                isDropdownSearchable={true}
                styling={{
                    backgroundColor: "var(--backgrounds-lines-n-400)",
                    requiredTypeColor: disabled ? "var(--backgrounds-lines-n-500, #141922)" : undefined,
                    dropdownOverlayTop: "45px",
                    ...(props.premium ? { formFieldWidth: "100%", dropdownOverlayWidth: "320px" } : {}),
                    dropdownOverlayStyle: props.premium ? { "--premium-listing-overlay": 1 } : dropdownStyle
                }}
                requiredType={computedRequiredType}
                disableTooltip={true}
                dropdownOnSingleItemClick={dropdownOnSingleItemClick}
                firstElementIsSelectAll={true}
                dropdownSettings={{
                    hasDescriptionFields: true,
                    hasLockedFields: true,
                    useFullTextTitles: props.premium,
                    widthPercentage: props.premium ? "100%" : "169%"
                    //widthPercentage: "100%"
                }}
                multidropdownOptions={multidropdownOptions}
                useDropdownPlaceholderAsTag={useDropdownPlaceholderAsTag}
                hoverTooltip={hoverTooltip}
            />
        </FilterHeaderStyles>
    );
};
// #endregion

// #region EXPORTED COMPONENTS

/** Simple menu to be used for Organize button.
 * @param {Object} props
 * @param {string} [props.className] - Additional classes to be added to the component.
 * @param {Object} [props.style] - Additional styles to be added to the component.
 * @param {Array} [props.items] - Items to be displayed in the menu.
 * @param {function} [props.onItemClick] - Function to be called when an item is clicked.
 * @returns {JSX.Element} - Rendered OrganizeBtnMenu component.
 */
export const OrganizeBtnMenu = props => {
    const { className = "", style = {}, items = [], onItemClick } = props;

    return (
        <OrganizeButtonStyles className={`frame-349 ${className}`} style={style}>
            <div className="frame-348">
                {items.map((item, index) => {
                    const { disabled, value, name } = item || {};

                    return (
                        <div
                            className={`frame-75 ${disabled ? "disabled" : ""}`}
                            id={`organize-item-${index}`}
                            onClick={!disabled ? () => onItemClick(value) : undefined}
                            key={index}>
                            <div className="label">{name}</div>
                        </div>
                    );
                })}
            </div>
        </OrganizeButtonStyles>
    );
};

export function CustomSearch({
    enabled = true,
    highlighted,
    searchValue,
    setSearchValue,
    triggerTextChange = false,
    autoCompleteAPIData,
    onSelectedItemChange,
    onTextChange,
    onClearSearch,
    placeholder = "Search",
    noSearchResultsMessage = "No results found",
    formFieldProps = {}
}) {
    const [searchInput, setSearchInput] = useState("");
    const debouncedText = useDebounce(searchInput, 400);
    const location = useLocation();
    const { aiChatSidePanelOpen } = useContext(AppContext);

    // If highlighted is not explicitly provided, derive it from whether searchInput has a value
    const isHighlighted = highlighted !== undefined ? highlighted : searchInput?.length > 0;

    // #region EFFECTS
    useEffect(() => {
        if (setSearchValue) setSearchValue(debouncedText);
        if (onTextChange) onTextChange(debouncedText);
    }, [debouncedText]); //when debouncedText changes, call setSearchValue and onTextChange

    useEffect(() => {
        if (setSearchValue) setSearchValue(searchInput);
    }, [searchInput]); //when searchInput changes, call setSearchValue

    useEffect(() => {
        setSearchInput(searchValue);
    }, [searchValue]); //when searchValue changes, call setSearchInput

    useEffect(() => {
        setSearchInput("");
    }, [location]); //when location changes, reset search input
    // #endregion

    // #region METHODS

    const onClearSearchClicked = () => {
        setSearchInput("");
        if (onClearSearch) onClearSearch();
    };

    // #endregion

    // #region RENDER
    return (
        <StyledCustomSearch
            className={`CustomSearch ${isHighlighted ? "highlighted" : ""} ${aiChatSidePanelOpen ? "isSidePanelOpen" : ""}`}>
            <div className={`frame-48 ${searchInput ? "has-value" : "no-value"}`}>
                {searchInput ? (
                    <XCloseIcon className="x cursor-pointer" onClick={onClearSearchClicked} />
                ) : (
                    <IconSearch
                        className="x"
                        style={{ color: enabled ? "var(--text-icons-gray-100)" : "var(--text-icons-gray-300)" }}
                    />
                )}
            </div>

            <FormFieldTextAutocomplete
                className="custom-search"
                style={{ maxWidth: "312px" }}
                type="text"
                placeholder={placeholder}
                requiredType={!enabled ? "locked" : "simple"}
                varName="textAutocomplete"
                noSearchResultsHideMessage={false}
                noSearchResultsMessage={noSearchResultsMessage}
                itemNotSelectedWillClear={false}
                autoCompleteAPIData={autoCompleteAPIData}
                onSelectedItemChange={onSelectedItemChange}
                //onTextChange={onTextChange}
                onTextChange={setSearchInput}
                disableAssistiveText={true}
                disableTooltip={true}
                value={searchInput}
                triggerTextChange={triggerTextChange}
                onOnlyOneTriggerSelection={true}
                {...formFieldProps}
            />
        </StyledCustomSearch>
    );
    // #endregion
}
// #endregion
